import React from 'react';
import { CARD_DIVIDER_ZINDEX } from '../consts';
export var ShadowBehavior;
(function (ShadowBehavior) {
    ShadowBehavior["Border"] = "1px 0px 0px 1px #dfe5ea";
    ShadowBehavior["Shadow"] = "0px 0px 30px 5px rgb(67 2 168 / 13%)";
})(ShadowBehavior || (ShadowBehavior = {}));
export function ProductCardDivider({ dataHook, className, shadowBehavior, }) {
    const style = {
        gridRow: '1/-1',
        boxShadow: shadowBehavior,
        zIndex: CARD_DIVIDER_ZINDEX,
    };
    return React.createElement("div", { "data-hook": dataHook, className: className, style: style });
}
//# sourceMappingURL=ProductCardDivider.js.map